import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const NotificationComponent = React.lazy(() => import("../Components/RootComponents/NotificationComponent"));
const NotificationPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <NotificationComponent />
      </Suspense>
    </Fragment>
  );
};

export default NotificationPage;
